import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: number[] = [];

const templatePlaceholdersIdsSlice = createSlice({
  name: 'templatePlaceholdersIds',
  initialState,
  reducers: {
    addPlaceholderId: (state, action: PayloadAction<number>) => {
      if (!state.includes(action.payload)) {
        state.push(action.payload);
      }
    },
    removePlaceholderId: (state, action: PayloadAction<number>) => {
      return state.filter((id) => id !== action.payload);
    },
    clearPlaceholdersIds: () => initialState,
  },
});

export const { addPlaceholderId, removePlaceholderId, clearPlaceholdersIds } =
  templatePlaceholdersIdsSlice.actions;

export default templatePlaceholdersIdsSlice.reducer;

export const selectTemplatePlaceholdersIds = (state: { templatePlaceholdersIds: number[] }) =>
  state.templatePlaceholdersIds;
